module.exports = __webpack_public_path__ + "static/media/rain.b24a5d8c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rain.gif
// module id = 1199
// module chunks = 114